import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { apis, hooks } from "@vote4dance/judging-sdk";
import { useCompetition } from '../../base-react/hooks/Competition';
import { Loading } from '../../base-react/components/Loading';
import { AccessDenied } from '../../base-react/components/AccessDenied';
import { LoginRequired } from '../../base-react/components/LoginRequired';
var useSession = hooks.sessions.useSession;
var useConnectionState = apis.connections.useConnectionState;
export const EventFunctionaryOutlet = () => {
    const { event_id } = useParams();
    const [, event, , loading] = useCompetition(event_id);
    const sessionState = useSession();
    const { isConnected } = useConnectionState();
    const hasSession = Boolean(sessionState && sessionState.sessionInfo);
    const isAuthenticated = Boolean(sessionState && sessionState.sessionInfo && sessionState.sessionInfo.user_id != "0");
    if (loading || !event || !hasSession || !isConnected) {
        return React.createElement(Loading, null);
    }
    if (event.usercompetition_level == null || parseInt(String(event.usercompetition_level), 10) < 10) {
        return isAuthenticated ? React.createElement(AccessDenied, null) : React.createElement(LoginRequired, null);
    }
    return React.createElement(Outlet, null);
};
export default EventFunctionaryOutlet;
